import { useCallback } from 'react';
import { NodeSelection } from 'prosemirror-state';

import { EditorView } from '@lyearn/lygo-core';

import { setNodeAttrs } from '../../../../utils';
import { ImageLayoutTypes, MediaBlockLayoutTypes } from './types';

export const useTooltipMenuAction = (view: EditorView) => {
  return useCallback(
    (
      layout: MediaBlockLayoutTypes,
      setPopoverLayout: (popoverLayout: MediaBlockLayoutTypes) => void,
      event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    ) => {
      if (!view) {
        return;
      }
      const currentSelectionNode = (view.state.selection as NodeSelection).node;
      switch (layout) {
        case MediaBlockLayoutTypes.Center: {
          setNodeAttrs(view, view.state.selection.$from.pos, {
            ...currentSelectionNode?.attrs,
            width: null,
          });
          break;
        }
        case MediaBlockLayoutTypes.FullWidth: {
          setNodeAttrs(view, view.state.selection.$from.pos, {
            ...currentSelectionNode?.attrs,
            width: 100,
          });
          break;
        }
        case MediaBlockLayoutTypes.AddCaption: {
          setNodeAttrs(view, view.state.selection.$from.pos, {
            ...currentSelectionNode?.attrs,
            caption: currentSelectionNode?.attrs.caption === null ? '' : null,
          });
          break;
        }
        case MediaBlockLayoutTypes.Frames: {
          event.preventDefault();
          event.stopPropagation();
          setPopoverLayout(layout);
          break;
        }
        default:
          break;
      }
    },
    [view],
  );
};

export const useTooltipMenuPopoverAction = (view: EditorView) => {
  return useCallback(
    (layout: ImageLayoutTypes, toggle: () => void) => {
      if (!view) {
        return;
      }
      const currentSelectionNode = (view.state.selection as NodeSelection).node;
      switch (layout) {
        case ImageLayoutTypes.None:
        case ImageLayoutTypes.Card:
        case ImageLayoutTypes.Mobile:
        case ImageLayoutTypes.Web: {
          setNodeAttrs(view, view.state.selection.$from.pos, {
            ...currentSelectionNode?.attrs,
            layout: layout,
            width:
              layout === ImageLayoutTypes.Web ? 80 : layout === ImageLayoutTypes.Mobile ? 30 : null,
          });
          toggle();
          break;
        }
        default:
          break;
      }
    },
    [view],
  );
};
